module.exports = __webpack_public_path__ + "img/gi.7f390617.svg";